export const hasTezID = (id?: string | number): boolean => {
  if (!id) return false;
  if (typeof id === "number") {
    return id > 0;
  } else {
    if (id.length === 0) return false;
    return id != "0";
  }
};
